import classNames from "classnames"
import ReactValidator from "legacy/ReactValidator.es6"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import {
  boatDisplayText,
  definedOrNA,
  displayBoatType,
  inchesToFeet,
  isset,
} from "legacy/helpers.es6"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"
import Select from "react-select"

import Badge from "src/components/Badge"

class AssignModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      reservation: null,
      waitingForReservation: true,
      processing: false,
      reservationId: this.props.state.editReservationID,
    }

    // Create ref
    this.modalContainerRef = React.createRef()

    // Bind methods to this instance
    this.fetchReservation = this.fetchReservation.bind(this)
    this.changeValue = this.changeValue.bind(this)
    this.updateRemaining = this.updateRemaining.bind(this)
    this.saveNewAssignments = this.saveNewAssignments.bind(this)
    this.isAssignmentOnToday = this.isAssignmentOnToday.bind(this)
    this.formatSpacesToSelect = this.formatSpacesToSelect.bind(this)
    this.shouldUpdateRemaining = this.shouldUpdateRemaining.bind(this)
    this.assignmentsForm = this.assignmentsForm.bind(this)
    this.fullControlToggler = this.fullControlToggler.bind(this)
    this.assignAll = this.assignAll.bind(this)
    this.clearAll = this.clearAll.bind(this)
    this.spacesTheSame = this.spacesTheSame.bind(this)
    this.setAssignmentStatus = this.setAssignmentStatus.bind(this)
    this.boatInfo = this.boatInfo.bind(this)
    this.toggleMinimized = this.toggleMinimized.bind(this)
    this.noteChange = this.noteChange.bind(this)
    this.contactNoteChange = this.contactNoteChange.bind(this)
    this.loading = this.loading.bind(this)

    // Initialize validator
    this.validator = new ReactValidator()
  }

  componentDidMount() {
    $(this.modalContainerRef.current).modal({
      show: true,
      backdrop: "static",
      keyboard: false,
    })
    $(this.modalContainerRef.current).on(
      "hidden.bs.modal",
      this.props.handleHideModal
    )
    this.fetchReservation()
  }

  componentDidUpdate() {
    if (this.props.state.editReservationID !== this.state.reservationId) {
      this.setState({
        reservationId: this.props.state.editReservationID,
        waitingForReservation: true,
        reservation: null,
      })
      this.fetchReservation()
    }
  }

  fetchReservation() {
    $.get(
      "/manage/" +
        this.props.state.marinaSlug +
        "/reservations/" +
        this.props.state.editReservationID +
        "/assignments",
      (data) => {
        this.setState({
          waitingForReservation: false,
          reservation: data,
        })
      },
      "json"
    )
  }

  changeValue(day, value) {
    value = isset(value) ? value.value : null
    const assignments = this.state.reservation.assignments
    for (let i = 0, l = assignments.length; i < l; i++) {
      if (day === assignments[i].night) {
        assignments[i].space_id = value
      }
    }
    const reservation = this.state.reservation
    reservation.assignments = assignments
    this.setState({
      reservation,
      updatedRemainingAssignments: {
        day,
        value,
      },
    })
  }

  updateRemaining() {
    const day = this.state.updatedRemainingAssignments.day
    const value = this.state.updatedRemainingAssignments.value
    const assignments = this.state.reservation.assignments
    for (let i = 0, l = assignments.length; i < l; i++) {
      if (day === assignments[i].night || day < assignments[i].night) {
        assignments[i].space_id = value
      }
    }
    const reservation = this.state.reservation
    reservation.assignments = assignments
    this.setState({
      reservation,
      updatedRemainingAssignments: null,
    })
  }

  saveNewAssignments() {
    this.validator.displayErrors()
    this.setState({ validInputs: this.validator.allValid() })
    if (this.validator.allValid() === true) {
      this.setState({ processing: true })
      this.hasCompleted = false
      $.post(
        "/manage/" +
          this.props.state.marinaSlug +
          "/reservations/" +
          this.props.state.editReservationID +
          "/assignments",
        this.state.reservation,
        (data) => {
          this.props.loadPageData(() => {
            this.setState({ processing: false })
            $(this.modalContainerRef.current).modal("hide")
            this.props.resetPageLastUpdated()
          })
        }
      )
    }
  }

  isAssignmentOnToday(night) {
    return moment(night).format("YYYY-MM-DD") === this.props.state.night
  }

  formatSpacesToSelect() {
    const spaces = this.props.state.tableData.spaces
    const array = []
    for (let i = 0, l = spaces.length; i < l; i++) {
      array.push({
        value: spaces[i].id,
        label: spaces[i].name + " (" + spaces[i].type + ")",
      })
    }
    return array
  }

  shouldUpdateRemaining(night) {
    if (
      isset(this.state.updatedRemainingAssignments) &&
      this.state.updatedRemainingAssignments.day === night
    ) {
      const spaces = this.props.state.tableData.spaces
      for (let i = 0, l = spaces.length; i < l; i++) {
        if (spaces[i].id === this.state.updatedRemainingAssignments.value) {
          return (
            <div className="col-sm-12">
              <button
                type="button"
                className="btn btn-sm btn-danger bs-mt-3"
                onClick={() => this.updateRemaining()}
              >
                Update Remaining Assignments to {spaces[i].name}
              </button>
            </div>
          )
        }
      }
    }
  }

  assignmentsForm() {
    const assignments = this.state.reservation.assignments
    const spaces = this.formatSpacesToSelect()
    const html = [
      <div className="form-group bs-mb-0" key={-1}>
        <label>Assign All Dates</label>
        <div className="row nested-row">
          <div className="col-sm-7">
            <Select
              name="spaces"
              value={this.spacesTheSame()}
              options={spaces}
              onChange={this.assignAll}
            />
          </div>
          <div className="col-sm-5">
            <button
              type="button"
              className="btn btn-secondary"
              style={{ width: "100%", height: "36px" }}
              onClick={this.clearAll}
            >
              Clear All
            </button>
          </div>
        </div>
        <hr />
        {this.fullControlToggler()}
      </div>,
    ]
    for (let i = 0, l = assignments.length; i < l; i++) {
      html.push(
        <div
          className={classNames("form-group", {
            today: this.isAssignmentOnToday(assignments[i].night),
          })}
          key={i}
        >
          <div className="row nested-row">
            <div className="col-sm-7">
              <label>
                {moment(assignments[i].night).format("dddd Do, MMM YYYY")}
              </label>
              <Select
                name="spaces"
                value={assignments[i].space_id}
                options={spaces}
                onChange={(value) =>
                  this.changeValue(assignments[i].night, value)
                }
              />
            </div>
            <div className="col-sm-5">
              {isset(assignments[i].last_updated_at) ? (
                <div className="text-muted" style={{ marginBottom: 5 }}>
                  Last Update:{" "}
                  {moment(assignments[i].last_updated_at).format("lll")}
                </div>
              ) : (
                <div style={{ height: 24, width: 24 }} />
              )}
              <div className="btn-group" role="group">
                <button
                  type="button"
                  onClick={() => this.setAssignmentStatus(i, "in")}
                  className={classNames("btn", {
                    "btn-secondary": assignments[i].status !== "in",
                    "btn-primary": assignments[i].status === "in",
                  })}
                >
                  In
                </button>
                <button
                  type="button"
                  onClick={() => this.setAssignmentStatus(i, "out")}
                  className={classNames("btn", {
                    "btn-secondary": assignments[i].status !== "out",
                    "btn-tertiary": assignments[i].status === "out",
                  })}
                >
                  Out
                </button>
              </div>
            </div>
            {this.shouldUpdateRemaining(assignments[i].night)}
          </div>
        </div>
      )
    }
    return html
  }

  fullControlToggler() {
    return (
      <div>
        <div className="row nested-row">
          <div className="col-sm-7">
            <h4 className="assignment-section-headers">Assignments</h4>
          </div>
          <div className="col-sm-5">
            <h4 className="assignment-section-headers">
              Dockwalk Status
              <i
                className="fa-solid fa-circle-info cursor-pointer"
                data-content="The dockwalk status is a way for you to validate that boats are in their correct spaces each day. If you would like a faster way to do you dockwalks download the Dockwa app for iOS and sign in with your Dockwa account."
                style={{
                  color: "#A4A4A4",
                  fontSize: ".9em",
                  padding: "0 1rem",
                }}
                data-container="body"
                data-toggle="popover"
                data-placement="bottom"
                data-html="true"
              />
            </h4>
          </div>
        </div>
      </div>
    )
  }

  assignAll(assignAllTo) {
    const assignments = this.state.reservation.assignments
    for (let i = 0, l = assignments.length; i < l; i++) {
      assignments[i].space_id = assignAllTo.value
    }
    const reservation = this.state.reservation
    reservation.assignments = assignments
    this.setState({ reservation })
  }

  clearAll() {
    const assignments = this.state.reservation.assignments
    for (let i = 0, l = assignments.length; i < l; i++) {
      assignments[i].space_id = null
    }
    const reservation = this.state.reservation
    reservation.assignments = assignments
    this.setState({ reservation })
  }

  spacesTheSame() {
    const assignments = this.state.reservation.assignments
    const spaceId = assignments[0].space_id
    let sameSpace = true
    for (let i = 1, l = assignments.length; i < l; i++) {
      if (assignments[i].space_id !== spaceId) {
        sameSpace = false
      }
    }
    return sameSpace ? spaceId : null
  }

  setAssignmentStatus(index, status) {
    const assignments = this.state.reservation.assignments
    if (assignments[index].status === status) {
      // clear the status if clicked again
      assignments[index].status = null
    } else {
      assignments[index].status = status
    }
    assignments[index].last_updated_at = moment().toISOString()
    const reservation = this.state.reservation
    reservation.assignments = assignments
    this.setState({ reservation })
  }

  boatInfo() {
    return (
      "Name: " +
      definedOrNA(this.state.reservation.contact_boat.name) +
      "<br />Make: " +
      definedOrNA(this.state.reservation.contact_boat.make) +
      "<br />Model: " +
      definedOrNA(this.state.reservation.contact_boat.model) +
      "<br />Type: " +
      displayBoatType(
        definedOrNA(this.state.reservation.contact_boat.boat_type)
      ) +
      "<br />LOA: " +
      inchesToFeet(this.state.reservation.contact_boat.length_overall) +
      "'" +
      "<br />Beam: " +
      inchesToFeet(this.state.reservation.contact_boat.beam) +
      "'" +
      "<br />Draft: " +
      inchesToFeet(this.state.reservation.contact_boat.draw) +
      "'" +
      "<br />Year: " +
      definedOrNA(this.state.reservation.contact_boat.year) +
      "<br />Port: " +
      definedOrNA(this.state.reservation.contact_boat.hailing_port) +
      "<br />Registation: " +
      definedOrNA(this.state.reservation.contact_boat.registration_number)
    )
  }

  toggleMinimized() {
    this.props.setGlobalState({
      modalMinimized: !this.props.state.modalMinimized,
    })
  }

  noteChange(event) {
    const reservation = this.state.reservation
    reservation.note = event.target.value
    this.setState({ reservation })
  }

  contactNoteChange(event) {
    const reservation = this.state.reservation
    reservation.contact.note = event.target.value
    this.setState({ reservation })
  }

  loading() {
    if (this.state.waitingForReservation) {
      return (
        <div
          className="text-success text-center"
          style={{ padding: "40px", fontSize: "2rem" }}
        >
          Loading Reservation...
        </div>
      )
    } else {
      return (
        <div>
          <div className="modal-header">
            <h4 className="modal-title">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  "/manage/" +
                  this.props.state.marinaSlug +
                  "/reservations/" +
                  this.state.reservation.encoded_id
                }
              >
                #{this.state.reservation.encoded_id}
              </a>
              <span className="bs-ml-4">
                <Badge
                  color="neutral"
                  text={this.state.reservation.requested_space_type}
                />
              </span>
              {this.state.reservation.contact_boat.beam >= 17 * 12 ? (
                <span className="bs-ml-2">
                  <Badge
                    color="warning"
                    text={`Wide Beam: ${inchesToFeet(
                      this.state.reservation.contact_boat.beam
                    )}'`}
                  />
                </span>
              ) : null}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="float-right"
                href={
                  "/manage/" +
                  this.props.state.marinaSlug +
                  "/contacts/" +
                  this.state.reservation.contact.id
                }
              >
                {this.state.reservation.contact.name}
              </a>
              <div className="regular-modal-btns float-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-3"
                  style={{ width: "70px" }}
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <NextButton
                  processing={this.state.processing}
                  click={this.saveNewAssignments}
                  icon=""
                  text="Save"
                  processingText="Saving..."
                />
              </div>
            </h4>
          </div>
          <div className="modal-body">
            <div className="row nested-row">
              <div className="col-xs-6">
                <div className="title">
                  Vessel
                  <i
                    className="fa-solid fa-circle-info cursor-pointer"
                    data-content={this.boatInfo()}
                    style={{
                      color: "#A4A4A4",
                      fontSize: ".9em",
                      padding: "0 1rem",
                    }}
                    data-container="body"
                    data-toggle="popover"
                    data-placement="bottom"
                    data-html="true"
                  />
                </div>
                <div className="value">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      "/manage/" +
                      this.props.state.marinaSlug +
                      "/contacts/" +
                      this.state.reservation.contact.id +
                      "/contact_boats/" +
                      this.state.reservation.contact_boat.id +
                      "/edit"
                    }
                  >
                    {boatDisplayText(
                      this.state.reservation.contact_boat.name,
                      inchesToFeet(
                        this.state.reservation.contact_boat.length_overall
                      ),
                      this.state.reservation.contact_boat.boat_type
                    )}
                  </a>
                </div>
              </div>
              <div className="col-xs-6">
                <div className="title">Itinerary</div>
                <div className="value">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      "/manage/" +
                      this.props.state.marinaSlug +
                      "/reservations/night/" +
                      moment(
                        this.state.reservation.check_in_date.substring(
                          0,
                          this.state.reservation.check_in_date.indexOf("T")
                        )
                      ).format("YYYY-MM-DD")
                    }
                  >
                    {moment(
                      this.state.reservation.check_in_date.substring(
                        0,
                        this.state.reservation.check_in_date.indexOf("T")
                      )
                    ).format("MMMM Do, YYYY")}
                  </a>
                  &nbsp;-&nbsp;
                  {moment(
                    this.state.reservation.check_out_date.substring(
                      0,
                      this.state.reservation.check_in_date.indexOf("T")
                    )
                  ).format("MMMM Do, YYYY")}
                </div>
              </div>
              <div className="col-xs-6">
                <div className="title">Electric</div>
                <div className="value">
                  {isset(this.state.reservation.electrical_rate)
                    ? this.state.reservation.electrical_rate.power_type
                    : "None"}
                </div>
              </div>
              <div className="col-xs-6">
                <div className="title">Special Request</div>
                <div className="value">
                  {isset(this.state.reservation.special_request)
                    ? this.state.reservation.special_request
                    : "None"}
                </div>
              </div>
            </div>
            <hr className="bs-mb-1" />
            <div className="row nested-row">
              <div className="col-sm-6">
                <div className="title">Reservation Note</div>
                <textarea
                  className="form-control"
                  onChange={this.noteChange}
                  value={this.state.reservation.note}
                />
              </div>
              <div className="col-sm-6">
                <div className="title">Contact Note</div>
                <textarea
                  className="form-control"
                  onChange={this.contactNoteChange}
                  value={this.state.reservation.contact.note}
                />
              </div>
            </div>
            <hr />
            <div>{this.assignmentsForm()}</div>
          </div>
        </div>
      )
    }
  }

  render() {
    return (
      <div
        className={classNames("assignment-modal modal in", {
          minimized: this.props.state.modalMinimized,
        })}
        ref={this.modalContainerRef}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-controls">
              <div
                className="modal-control-item"
                onClick={this.saveNewAssignments}
              >
                {this.state.processing ? (
                  <i className="fa-solid fa-spinner-third fa-spin" />
                ) : (
                  <i className="fa-solid fa-circle-check" />
                )}
                {this.state.processing ? "Saving..." : "Save"}
              </div>
              <div
                className="modal-control-item minimize-modal"
                onClick={this.toggleMinimized}
              >
                {this.props.state.modalMinimized ? (
                  <i className="fa-solid fa-chevron-left" />
                ) : (
                  <i className="fa-solid fa-window-minimize" />
                )}
                {this.props.state.modalMinimized ? "Expand" : "Minimize"}
              </div>
              <div className="modal-control-item" data-dismiss="modal">
                <i className="fa-solid fa-ban" />
                Cancel
              </div>
            </div>
            {this.loading()}
          </div>
        </div>
      </div>
    )
  }
}

AssignModal.propTypes = {
  state: PropTypes.shape({
    editReservationID: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      .isRequired,
    marinaSlug: PropTypes.string.isRequired,
    night: PropTypes.string.isRequired,
    tableData: PropTypes.shape({
      spaces: PropTypes.array.isRequired,
    }).isRequired,
    modalMinimized: PropTypes.bool,
  }).isRequired,
  handleHideModal: PropTypes.func.isRequired,
  loadPageData: PropTypes.func.isRequired,
  resetPageLastUpdated: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
}

export default AssignModal
